<template>
  <div
    v-if="localLists.length > 0"
    class="suggestion-lists"
    data-track-as="searchSuggestions"
  >
    <div
      v-for="(list, i) of localLists"
      :key="i"
      class="suggestion-lists__list"
    >
      <h3 class="suggestion-lists__title">{{ list.title }}</h3>
      <ul class="suggestion-lists__link-list">
        <li
          v-for="link of list.links"
          :key="link.title"
          class="suggestion-lists__item"
        >
          <a class="suggestion-lists__link" :href="link.target">
            <dotcom-icon
              name="arrow-right-long"
              art="regular"
              color="--c-primary-color-3"
              hover-color="--c-primary-color-2"
              class="suggestion-lists__icon"
            />
            {{ link.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import isString from 'lodash/isString'

export default {
  name: 'SuggestionLists',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    lists: {
      type: [Array, String],
      default: () => [],
    },
  },
  data() {
    return {
      localLists: [],
    }
  },

  created() {
    this.initLinks()
  },

  methods: {
    initLinks() {
      if (this.lists) {
        this.localLists = isString(this.lists)
          ? JSON.parse(this.lists)
          : this.lists
      }
    },
  },
}
</script>

<style lang="postcss">
.suggestion-lists {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-8);
  flex-wrap: wrap;
}

.suggestion-lists__title {
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--c-primary-neutral-1);
  margin-bottom: var(--spacing-4);
}

.suggestion-lists__item {
  min-width: 200px;
}

.suggestion-lists__link-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  list-style: none;
}

.suggestion-lists__link {
  font-size: 16px;
  line-height: 1.2;
  display: inline;
  font-weight: 700;
  word-break: break-word;
  color: var(--c-primary-color-3);

  &:hover {
    color: var(--c-primary-color-2);
    .suggestion-lists__icon {
      color: var(--c-primary-color-2);
    }
  }
}
.suggestion-lists__icon {
  margin-right: var(--spacing-2);
}
</style>
